import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleServicesUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <circle id="pic_circle_services-unselected_svg__a" cx={28} cy={28} r={28} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="pic_circle_services-unselected_svg__b" fill="#fff">
          <use xlinkHref="#pic_circle_services-unselected_svg__a" />
        </mask>
        <use fill="#999" xlinkHref="#pic_circle_services-unselected_svg__a" />
        <path
          d="M25.41 13.98h-.1a1 1 0 00-1.01 1.04l.25 7.9a.99.99 0 01-1 1.03 1 1 0 01-1.01-.97l-.07-8.04a1 1 0 00-1-.96h-.15a1 1 0 00-1 .96l-.11 8a1 1 0 01-1.01.98c-.57 0-1-.47-1-1.04l.25-7.9a.99.99 0 00-1-1.04h-.12c-.53 0-.97.43-1 .97L16 23.09a5.16 5.16 0 003.34 5.24l-1.01 11.38a3 3 0 003.01 3.23c1.76 0 3.13-1.5 3.02-3.23l-1.01-11.38a5.22 5.22 0 003.34-5.24l-.28-8.15a1.02 1.02 0 00-1.01-.96z"
          fill="#FFF"
          mask="url(#pic_circle_services-unselected_svg__b)"
        />
        <g mask="url(#pic_circle_services-unselected_svg__b)">
          <path d="M34.2 32h5c.28 0 .5.22.5.5V40a3 3 0 01-6 0v-7.5c0-.28.22-.5.5-.5z" fill="#CCC" />
          <path
            d="M37.62 12.86a8.3 8.3 0 00-4.9 7.25l-.22 6.01a2.1 2.1 0 002.07 2.18v2.46h4.25V13.62c0-.6-.65-.98-1.2-.76z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleServicesUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleServicesUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleServicesUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
